module.exports = __webpack_public_path__ + "static/视觉安规证书-d3e0af667e83f629bc972d9f642f8500.jpg";